import { useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import TeamSection from '../components/TeamSection';

const Team = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <PageLayout title="Team">
      <TeamSection />
    </PageLayout>
  );
};

export default Team;
